import DataTableViewer from './DataTableViewer';

export default DataTableViewer;
